import PropTypes from 'prop-types';
import React from 'react';

import Button from '@cdo/apps/legacySharedComponents/Button';
import {resourceShape} from '@cdo/apps/levelbuilder/shapes';
import DropdownButton from '@cdo/apps/templates/DropdownButton';
import i18n from '@cdo/locale';

export default class ResourcesDropdown extends React.Component {
  static propTypes = {
    resources: PropTypes.arrayOf(resourceShape).isRequired,
    studentFacing: PropTypes.bool,
  };

  handleItemClick = (e, resource) => {
    // Needed so that we can keep the href on the link to allow for standard link interactions
    e.preventDefault();
    const resourceUrl = resource.url;

    window.open(resourceUrl, 'noopener', 'noreferrer');
  };

  render() {
    const {resources} = this.props;

    const dropdownResources = resources.map(resource => (
      <a
        key={resource.key}
        href={resource.url}
        onClick={e => this.handleItemClick(e, resource)}
      >
        {resource.name}
      </a>
    ));
    return (
      <div style={styles.dropdown}>
        <DropdownButton
          text={
            this.props.studentFacing
              ? i18n.studentResources()
              : i18n.teacherResources()
          }
          color={
            this.props.studentFacing
              ? Button.ButtonColor.gray
              : Button.ButtonColor.blue
          }
          size={
            this.props.studentFacing
              ? Button.ButtonSize.large
              : Button.ButtonSize.default
          }
        >
          {dropdownResources}
        </DropdownButton>
      </div>
    );
  }
}

const styles = {
  dropdown: {
    display: 'inline-block',
    marginRight: 5,
  },
};
